import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMobile = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 12 20",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M1.41669 19.1667C1.08335 19.1667 0.791687 19.0417 0.541687 18.7917C0.291687 18.5417 0.166687 18.25 0.166687 17.9167V2.08337C0.166687 1.75004 0.291687 1.45837 0.541687 1.20837C0.791687 0.958374 1.08335 0.833374 1.41669 0.833374H10.5834C10.9167 0.833374 11.2084 0.958374 11.4584 1.20837C11.7084 1.45837 11.8334 1.75004 11.8334 2.08337V17.9167C11.8334 18.25 11.7084 18.5417 11.4584 18.7917C11.2084 19.0417 10.9167 19.1667 10.5834 19.1667H1.41669ZM1.41669 16.0417H10.5834V3.95837H1.41669V16.0417Z" })
});
export default SvgMobile;
